module.exports = __webpack_public_path__ + "media/images/flags/32/French-Polynesia-f2ac36b269917a86a7ccfc725673169e.png";